'use client';

import { AppPage } from '@/components/AppPage';
import { useAppStore } from '@/stores/appStore';
import { getFundsDetails } from '@/utils';
import { Funds } from '@wolfejs/ms-ui/Funds/Funds';
import type { BalanceInfo } from '@wolfejs/ms-ui/Funds/types';

import type { UserEntity } from '@wolfejs/ms-api-js/src/types/users';
import Cookies from 'js-cookie';
import { useEffect, useState } from 'react';
import { fundModes } from './constants';

export const FundsContainer = () => {
  const [balance, setBalance] = useState<BalanceInfo>({balanceType: '', amount: 0, loading: true});
  const [balanceError, setBalanceError] = useState<string>();
  const setAvailableFunds = useAppStore(state => state.setAvailableFunds);

  const userRaw = Cookies.get('user');
  let user: UserEntity | undefined;
  if (userRaw) {
    user = JSON.parse(userRaw) as UserEntity;
  }

  useEffect(() => {
    (async () => {
      const response = await getFundsDetails();
      if (typeof response === 'string') {
        setBalanceError(response);
        return;
      }
      if (!response) {
        setAvailableFunds(undefined);
        return;
      }
      setBalance({
        balanceType: 'available',
        amount: response.amount ?? 0,
        loading: false
      });
      setAvailableFunds(response.amount);
    })();
  }, [setAvailableFunds]);

  return (
    <AppPage>
      <Funds fundModes={fundModes} balanceInfo={balance} balanceError={balanceError} />
    </AppPage>
  );
};
